import React, { useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, Button, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import { HEIGHT as BUTTON_HEIGHT } from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import RentReportingSection from 'features/feed/components/rent-reporting/RentReportingSection';
import Section from 'design-system/Section';
import { StyleSheet } from 'react-native';
import LoanItemsList from 'features/borrow/components/LoanItemsList';
import Text from 'design-system/Text';
import UtilitiesCard from 'features/borrow/components/UtilitiesCard';
const strings = {
    headerTitle: 'Build credit',
    title: 'How to build your credit history',
    subTitle: 'Building your credit history takes time, but these simple steps will help you get there faster',
    sectionTitle: 'Other offers',
    sectionSubTitle: 'Using credit responsibly can be a good way to build your history. Explore these products to find options suited to you',
};
const CreditScoreBuildCreditScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const scrollViewStyle = useMarginBottom('paddingBottom', BUTTON_HEIGHT + rem(16), paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={scrollViewStyle}>
            <ScreenInfoHeader title={strings.title} subTitle={strings.subTitle} style={{ marginTop: rem(8) }}/>
            <RentReportingSection emptyCardButtonBrandReversed/>
            <UtilitiesCard />
            <Section title={strings.sectionTitle} style={styles.section}>
              <Text TextThin-16 Secondary style={styles.sectionSubTitle}>
                {strings.sectionSubTitle}
              </Text>
              <LoanItemsList excludeKeys={['broadband', 'energy']}/>
            </Section>
          </Animated.ScrollView>
          <Button floating brand title="Close" onPress={() => navigation.popToTop()}/>
        </AppView>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    section: {
        marginTop: rem(8),
    },
    sectionSubTitle: {
        marginBottom: rem(16),
        paddingHorizontal: rem(16),
    },
});
export default CreditScoreBuildCreditScreen;
